module.exports = __webpack_public_path__ + "static/contact-bfe80b45a77ed357b6e437ca6b0048c4.svg";